const IMAGES = {
    'person-talking' : 'https://lh3.googleusercontent.com/drive-viewer/AEYmBYRwONCDOjpm-tSJEAe9DCASUxTJSxPTK_IYewXlr8kJ03LAv5oXS-_ASR_f9NE-1DioGs8P-_N1l6UEU-U20IoslFb8rw=s2560',
    'rob-2': 'https://lh3.googleusercontent.com/drive-viewer/AEYmBYQvWLfCL1Bn8FrsYk9qsJ1uEIHUAVn1YvTh34KaXlW46UTDzudI6P7uRM7xq6VYt4F2n7XHpGYeQPmRHqJ5JSqf6RHwqQ=s2560',
    'rob-3': 'https://lh3.googleusercontent.com/drive-viewer/AEYmBYQ_Za6eQajkz5mVPjaTg_2U9p_YmW6zIea46Dcp9Hj6VCf-RkQuCvbQhzNL-GNds9Ja32CFt71y7m7lVYLz0UzRQlE1=s2560'
}

export default IMAGES;